// extracted by mini-css-extract-plugin
module.exports = {"animationE":"animationE_animationE__iD1sI"};